import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-mediego-newsletter-item',
    template: `
    <mat-list-item class="active">
      <mat-icon color="primary">mail_outline</mat-icon>&nbsp;{{ name }}
    </mat-list-item>
  `,
    styleUrls: [],
    standalone: false
})
export class NewsletterItemComponent {
  @Input() name: string
}
